import { render, staticRenderFns } from "./favorites.vue?vue&type=template&id=c4033714&scoped=true"
import script from "./favorites.vue?vue&type=script&lang=js"
export * from "./favorites.vue?vue&type=script&lang=js"
import style0 from "./favorites.vue?vue&type=style&index=0&id=c4033714&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4033714",
  null
  
)

export default component.exports